@if (mediaItems.length > 1) {
  <div class="thumbnails-outer-container">
    @if (mediaItems.length > thumbnailsPerPage) {
      <button
        type="button"
        siriusButton
        buttonType="linkstyle"
        size="small"
        iconName="caret_left"
        aria-label="Previous thumbnails"
        (click)="previousThumbnails()"
        [disabled]="!showPrevThumbnailButton"
      class="thumbnail-nav thumbnail-nav--prev"></button>
    }
    <div #thumbnailsContainer class="thumbnails-container">
      <div class="thumbnails-wrapper">
        @for (item of mediaItems; track item; let i = $index) {
          <button
            type="button"
            (click)="thumbnailClick.emit(i)"
            class="thumbnail-item"
            [class.active]="i === currentIndex"
            [attr.aria-label]="'Show image ' + (i + 1)"
            [attr.aria-current]="i === currentIndex ? 'true' : null">
            @if (getThumbnailMediaItem(item)) {
              <sirius-image-item
                [image]="getThumbnailMediaItem(item)!"
                fit="cover"
                [imageData]="imageData"
                [autocrop]="false">
              </sirius-image-item>
            }
            @if (item.type === 'video') {
              <span class="play-button" aria-hidden="true"></span>
            }
          </button>
        }
      </div>
    </div>
    @if (mediaItems.length > thumbnailsPerPage) {
      <button
        type="button"
        siriusButton
        buttonType="linkstyle"
        size="small"
        iconName="caret_right"
        aria-label="Next thumbnails"
        (click)="nextThumbnails()"
        [disabled]="!showNextThumbnailButton"
      class="thumbnail-nav thumbnail-nav--next"></button>
    }
  </div>
}
